// extracted by mini-css-extract-plugin
var _1 = "BrandFieldShadow_root__8cf07";
export { _1 as "root" }
